import {
  ConversationTopicType,
  type AssistantConversationsFilterInputType,
} from "@/types/graphql/partner.generated";
import { isEnumValue } from "@/partner/shared/utils/filterValues";

/**
 * Маппинг значений фильтра из querystring в аргумент запроса диалогов.
 * Приём и утилиты те же, что в `features/refunds/model/buildRefundsFilter.ts`:
 * мусор в enum-значении отбрасывается, пустой результат отдаётся как
 * `undefined`, а не `{}`.
 */
export function buildConversationsFilter(
  filter: Record<string, unknown>
): AssistantConversationsFilterInputType | undefined {
  const result: AssistantConversationsFilterInputType = {};

  if (typeof filter.search === "string" && filter.search) {
    result.search = filter.search;
  }

  if (isEnumValue(ConversationTopicType, filter.topic)) {
    result.topic = filter.topic;
  }

  // Селект «Обращение» хранит в querystring "yes"/"no" (общий приём с
  // cleanFilterValues, которая уже приводит "true"/"false" к boolean, но
  // здесь значения свои, поэтому проверяем явно).
  if (filter.hasRequest === "yes" || filter.hasRequest === true) {
    result.hasRequest = true;
  } else if (filter.hasRequest === "no" || filter.hasRequest === false) {
    result.hasRequest = false;
  }

  return Object.keys(result).length > 0 ? result : undefined;
}
